import React, { Component } from "react";
import { MDBBtn, MDBIcon, MDBSpinner } from "mdbreact";
import ApprovalDetailModal from "./ApprovalDetailModal";
import "./MultiTenancy.css";

/**
 * Pending Associations Inbox — Mockup #2
 *
 * Lists all pending Secondary Operator association requests for the current
 * operator. Each card opens an ApprovalDetailModal where the operator can
 * accept the billing acknowledgment and approve / reject the request.
 *
 * Props:
 *   pendingRequests       - array of pending request objects (see mock below)
 *   onApprove(requestId)  - called after acknowledgment + approve
 *   onReject(requestId)   - called after reject
 *   loading               - boolean
 */
class PendingAssociationsInbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRequest: null,
            isModalOpen: false,
        };
    }

    openModal = (request) => {
        this.setState({ selectedRequest: request, isModalOpen: true });
    };

    closeModal = () => {
        this.setState({ selectedRequest: null, isModalOpen: false });
    };

    handleApprove = (requestId) => {
        if (this.props.onApprove) this.props.onApprove(requestId);
        this.closeModal();
    };

    handleReject = (requestId) => {
        if (this.props.onReject) this.props.onReject(requestId);
        this.closeModal();
    };

    renderRequestCard = (req) => {
        return (
            <div key={req.id} className="mt-inbox-card">
                <div className="mt-inbox-card-header">
                    <span className="mt-status-badge status-pending">
                        <MDBIcon icon="bell" /> Pending
                    </span>
                    <span className="mt-muted">
                        Requested: {req.requestedAt}
                    </span>
                </div>

                <h5 className="mt-inbox-card-title">
                    <strong>{req.primaryOperatorName}</strong> has requested you
                    as Secondary Operator
                </h5>

                <div className="mt-inbox-card-body">
                    <div className="mt-inbox-row">
                        <span className="mt-label">Venue:</span>
                        <span>{req.venueName}</span>
                    </div>
                    <div className="mt-inbox-row">
                        <span className="mt-label">Primary Operator:</span>
                        <span>{req.primaryOperatorName}</span>
                    </div>
                    <div className="mt-inbox-row">
                        <span className="mt-label">Requested By:</span>
                        <span>{req.requestedByEmail}</span>
                    </div>
                    <div className="mt-inbox-row">
                        <span className="mt-label">Permission Set:</span>
                        <span>{req.permissionSummary}</span>
                    </div>
                </div>

                <div className="mt-inbox-card-actions">
                    <MDBBtn
                        color="primary"
                        size="sm"
                        onClick={() => this.openModal(req)}
                    >
                        <MDBIcon icon="eye" /> Review & Respond
                    </MDBBtn>
                </div>
            </div>
        );
    };

    render() {
        const { pendingRequests, loading } = this.props;
        const { selectedRequest, isModalOpen } = this.state;

        const requests = pendingRequests || this.getMockData();

        return (
            <div className="mt-pending-inbox">
                <div className="mt-inbox-header">
                    <h4>
                        <MDBIcon icon="inbox" /> Pending Venue Associations
                    </h4>
                    <span className="mt-inbox-count">
                        {requests.length} pending
                    </span>
                </div>

                {loading ? (
                    <div className="mt-loading">
                        <MDBSpinner small />
                    </div>
                ) : requests.length === 0 ? (
                    <div className="mt-empty-state">
                        <MDBIcon icon="check-circle" size="3x" />
                        <p>You have no pending association requests.</p>
                    </div>
                ) : (
                    <div className="mt-inbox-list">
                        {requests.map(this.renderRequestCard)}
                    </div>
                )}

                <ApprovalDetailModal
                    isOpen={isModalOpen}
                    request={selectedRequest}
                    onApprove={this.handleApprove}
                    onReject={this.handleReject}
                    onClose={this.closeModal}
                />
            </div>
        );
    }

    getMockData = () => [
        {
            id: "req-001",
            primaryOperatorName: "RoamingiQ Demo Managed Properties",
            primaryOperatorId: "OP-3F9X-1024",
            venueName: "Walpole Apartments",
            venueAddress: "1 Demo St, Walpole, MA 02081",
            requestedAt: "June 10, 2026 09:32 AM EDT",
            requestedByEmail: "jdoe@roamingiq.com",
            permissionSummary:
                "Property Support (view + edit subscriptions)",
            permissions: {
                viewVenue: true,
                editVenueSettings: false,
                viewEquipment: true,
                viewUsers: true,
                createUsers: false,
                editUsers: false,
                deleteUsers: false,
                viewSubscriptions: true,
                createSubscriptions: true,
                editSubscriptions: true,
                deleteSubscriptions: false,
                createResidentTickets: true,
                viewResidentTickets: true,
                viewResidentTicketDetails: false,
                editResidentTickets: false,
                createPropertyTickets: true,
                viewPropertyTickets: true,
                manageAdmins: false,
            },
        },
        {
            id: "req-002",
            primaryOperatorName: "SmartAira",
            primaryOperatorId: "OP-SMRT-AIRA",
            venueName: "Cortes Camelback",
            venueAddress:
                "4040 N Scottsdale Rd, Scottsdale, AZ 85251",
            requestedAt: "June 9, 2026 02:14 PM EDT",
            requestedByEmail: "admin@smartaira.com",
            permissionSummary: "Read-only (view venue + subscriptions)",
            permissions: {
                viewVenue: true,
                editVenueSettings: false,
                viewEquipment: true,
                viewUsers: true,
                createUsers: false,
                editUsers: false,
                deleteUsers: false,
                viewSubscriptions: true,
                createSubscriptions: false,
                editSubscriptions: false,
                deleteSubscriptions: false,
                createResidentTickets: false,
                viewResidentTickets: true,
                viewResidentTicketDetails: false,
                editResidentTickets: false,
                createPropertyTickets: false,
                viewPropertyTickets: true,
                manageAdmins: false,
            },
        },
    ];
}

export default PendingAssociationsInbox;
